<script setup>

import {computed, defineEmits, defineProps} from 'vue'
import {useStore} from "vuex";

const store = useStore()

const emit = defineEmits(['callback'])

const props = defineProps({
  taskId: { type: String, default: '' },
  emoji: { type: String, default: '' },
  reacts: { type: Array },
  total: { type: Number, default: 0 },
})

const tooltipsText = computed(() => {
  const reacts = props.reacts || []
  const count = reacts.length

  if (count === 0) return ''
  if (count === 1) return `${reacts[0]?.user_name} reacts with this`

  if (count <= 3) {
    const names = reacts.slice(0, count).map(r => r?.user_name).join(', ')
    return `${names} react with this`
  }

  const names = reacts.slice(0, 3).map(r => r?.user_name).join(', ')
  return `${names} and ${count - 3} more react with this`
})

function makeOrUpdateReact() {
  store.dispatch('comments/updateReactForTask', {task_id: props.taskId, content: props.emoji } )
      .then(res => {
        emit('callback', res.data.data)
      })
      .catch(() => {})
      .finally(() => {})
}


</script>

<template>
  <div
      @click.prevent="makeOrUpdateReact"
      data-bs-toggle="tooltip"
      data-bs-custom-class="react-custom-tooltip"
      data-bs-placement="top"
      data-bs-dismiss="hover"
      data-bs-delay-hide="2"
      data-bs-html="true" :title="tooltipsText"
      class="card bg-gray-200 d-flex flex-row align-items-center rounded-sm w-120px p-2 text-gray-400 text-hover-primary fw-bold">
    {{ total }}
    <i v-if="emoji" class="fa cursor-pointer fw-bold fs-2 ms-2 text-primary" v-html="emoji"></i>
    <i v-else class="fa fa-thumbs-up cursor-pointer fw-bold fs-2 ms-2 text-primary"></i>
  </div>
</template>

<style>

.react-custom-tooltip {
  color: white !important;
  background-color: var(--bs-dark) !important;
  text-align: center !important;
  max-width: 200px !important;
  padding: 6px 10px !important;
  border-radius: 4px !important;
  word-wrap: break-word !important;
  white-space: normal !important;
}


</style>